/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
// components
import ExternalSelectAutocomplete from 'react-select';
import { Grid, Input } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
// styled
import { StyledWrapperInput } from '../../../assets/styles/styles';

const CardBankAccount = (props) => {
  const { bank, accountType, accountNumber, banksItems, accountsTypesItems, disabled, onChange } =
    props;

  return (
    <SimpleCard
      contentHeader={
        <article className="d-flex flex-column">
          <p className="simplecard__title">¿Dónde quieres que te depositemos tus acreencias?</p>
          <p className="simplecard__subtitle">Déjanos una cuenta donde depositar tus saldos a favor.</p>
        </article>
      }
      disabled={disabled}
    >
      <Grid row className="m-0 padding-16 p-md-6">
        <Grid className="p-0 pr-md-4 mb-2 position-static" col={12} md={4}>
          <label className="label-select-autocomplete">Banco</label>
          <ExternalSelectAutocomplete
            className="select-autocomplete-coopeuch external-select-autocomplete"
            classNamePrefix="select-autocomplete-coopeuch"
            value={{
              value: bank.value.codigo,
              label: bank.value.descripcion,
            }}
            noOptionsMessage={() => 'Sin opciones'}
            onChange={(item) =>
              onChange({
                field: 'bank',
                property: 'value',
                value: { codigo: item.value, descripcion: item.label },
              })
            }
            options={banksItems}
          />
        </Grid>
        <Grid className="p-0 pr-md-4 mb-2 position-static" col={12} md={4}>
          <label className="label-select-autocomplete">Tipo de cuenta</label>
          <ExternalSelectAutocomplete
            className="select-autocomplete-coopeuch external-select-autocomplete"
            classNamePrefix="select-autocomplete-coopeuch"
            value={{
              value: accountType.value.codigo,
              label: accountType.value.descripcion,
            }}
            noOptionsMessage={() => 'Sin opciones'}
            onChange={(item) =>
              onChange({
                field: 'accountType',
                property: 'value',
                value: { codigo: item.value, descripcion: item.label },
              })
            }
            options={accountsTypesItems}
          />
        </Grid>
        <Grid className="p-0 mb-2 position-static" col={12} md={4}>
          <StyledWrapperInput>
            <Input
              value={accountNumber.value}
              label="Número de cuenta"
              assistText={[
                {
                  text: 'Sólo números',
                  type: 'assist',
                },
              ]}
              onChange={(e) =>
                onChange({
                  field: 'accountNumber',
                  property: 'value',
                  value: e,
                })
              }
              onlyNumber
              maxLength={20}
            />
          </StyledWrapperInput>
        </Grid>
      </Grid>
    </SimpleCard>
  );
};

CardBankAccount.defaultProps = {
  rut: { value: '', isValid: () => {}, errors: [] },
  firstName: { value: '', isValid: () => {}, errors: [] },
  lastName: { value: '', isValid: () => {}, errors: [] },
  maternalLastName: { value: '', isValid: () => {}, errors: [] },
  profession: { value: {}, isValid: () => {}, errors: [] },
  professionItems: [],
  disabled: false,
  onChange: () => null,
};

export default CardBankAccount;
